import screenfull from "screenfull";
import IGame from "./game/IGame";
import System from "./system/System";

export function init(game: IGame, system: System) {

    window.addEventListener('message', (message) => {
        windowMessage(message, game);
    });

    window.addEventListener("unload", unload.bind(this, system), false);
    window.addEventListener("beforeunload", unload.bind(this, system), false);

    document.addEventListener('gesturestart', function (e) {
        e.preventDefault();
    });
}


function windowMessage(message: MessageEvent, game: IGame) {

    if(!message.data) {
        // console.warn("windowMessage", message);
        return;
    }

    switch(message.data.request)
    {
        case "fullscreen":
            if (screenfull.isEnabled) {
                screenfull.request && screenfull.request();
            }
            break;

        case "isAutostart":
            window.parent.postMessage({
                "isAutostart": game.autostart?.isAutostart()
            }, "*");
            break;
    }

}

async function unload(system: System) {

    console.log("unload");
    await system.unload();
    // events.dispatch(EVENTS.WINDOW_UNLOAD);

}